import cuid from "cuid";
import { DEPARTMENTS, SKILL_TYPES } from "utils/constants";

const resolveDepartmentFormState = (savedValues) => {
  const all = DEPARTMENTS;
  const excluded = all.filter((code) => !savedValues.includes(code));
  const isExcludeMode =
    excluded.length > 0 && excluded.length < savedValues.length;

  return {
    departmentSelection: isExcludeMode ? excluded : savedValues,
    departmentExclude: isExcludeMode,
  };
};

/** Collapse API department skill rows into one form row with multiselect state. */
export const collapseSkillsForForm = (skills = []) => {
  const departmentSkills = skills.filter(
    ({ type }) => type === SKILL_TYPES.DEPARTMENT,
  );
  const otherSkills = skills.filter(
    ({ type }) => type !== SKILL_TYPES.DEPARTMENT,
  );

  if (!departmentSkills.length) {
    return skills;
  }

  const savedValues = departmentSkills.map(({ value }) => value);

  return [
    ...otherSkills,
    {
      id: departmentSkills[0].id,
      type: SKILL_TYPES.DEPARTMENT,
      value: null,
      ...resolveDepartmentFormState(savedValues),
    },
  ];
};

/** Expand department multiselect (+ exclude) into one skill row per included value. */
export const expandSkillsForApi = (skills = []) => {
  return skills.flatMap((skill) => {
    if (skill.type !== SKILL_TYPES.DEPARTMENT) {
      const { departmentSelection, departmentExclude, ...apiSkill } = skill;
      return [apiSkill];
    }

    const selected = skill.departmentSelection || [];
    const exclude = !!skill.departmentExclude;
    const includedValues = exclude
      ? DEPARTMENTS.filter((code) => !selected.includes(code))
      : selected;

    return includedValues.map((value, index) => ({
      id: index === 0 && skill.id ? skill.id : cuid(),
      type: SKILL_TYPES.DEPARTMENT,
      value,
    }));
  });
};
